import {
  appMutations,
  appActions
} from '../../constants'
import ApiService from '../../services/ApiService'

const apiService = new ApiService()

const state = {
  dataFromAPI: {},
  textFromAPI: {},
  appId: null,
  appName: '',
  appLogoUrl: '',
  appDocumentList: [],
  appColors: {},
  appFont: '',
  urlAPI: '',
  appLogoFile: null,
  editorText: '',
  versionTimestamp: null
}

const mutations = {
  [appMutations.GET_DATA_FROM_API] (state, payload) {
    state.dataFromAPI = payload.dataFromAPI
  },
  [appMutations.GET_TEXT_FROM_API] (state, payload) {
    state.editorText = payload.editorText
  },
  [appMutations.POST_TEXT_TO_API] (state, payload) {
    state.textFromAPI = payload.textFromAPI
  },
  [appMutations.SET_URL_API] (state, payload) {
    state.urlAPI = payload.urlAPI
  },
  [appMutations.GET_APP_SETTINGS_FROM_API] (state, payload) {
    // console.log('appMutations.GET_APP_SETTINGS_FROM_API payload: ', payload.appSettings)
    state.appId = payload.appSettings.appId
    state.appName = payload.appSettings.appName
    state.appLogoUrl = payload.appSettings.logoUrl
    state.appDocumentList = payload.appSettings.appDocumentList
    state.appColors = payload.appSettings.appColors
    state.appFont = payload.appSettings.appFont
  },
  [appMutations.SET_APP_SETTINGS_ID] (state, payload) {
    state.appId = payload.appId
  },
  [appMutations.SET_APP_SETTINGS_NAME] (state, payload) {
    state.appName = payload.appName
  },
  [appMutations.SET_APP_SETTINGS_LOGO_URL] (state, payload) {
    state.appLogoUrl = payload.appLogoUrl
  },
  [appMutations.SET_APP_SETTINGS_DOCUMENT_LIST] (state, payload) {
    state.appDocumentList = payload.appDocumentList
  },
  [appMutations.SET_APP_SETTINGS_COLORS] (state, payload) {
    state.appColors = payload.appColors
  },
  [appMutations.SET_APP_SETTINGS_FONT] (state, payload) {
    state.appFont = payload.appFont
  },
  [appMutations.POST_APP_SETTINGS_LOGO] (state, payload) {
    state.appLogoFile = payload.appLogoFile
  },
  [appMutations.POST_APP_SETTINGS_COLORS] (state, payload) {
    state.appColors = payload.appColors
  },
  [appMutations.POST_APP_SETTINGS_FONT] (state, payload) {
    state.appFont = payload.appFont
  }
}

const actions = {
  [appActions.UPDATE_URL_API] (store, payload) {
    store.commit({
      type: appMutations.SET_URL_API,
      urlAPI: payload
    })
  },
  [appActions.UPDATE_DATA_FROM_API] (store) {
    return new Promise(resolve => {
      apiService.getMenuData().then(result => {
        store.commit({
          type: appMutations.GET_DATA_FROM_API,
          dataFromAPI: result
        })
        resolve()
      }).catch((err) => {
        // console.log('UPDATE_DATA_FROM_API err: ', err)
        return err
      })
    })
  },
  [appActions.UPDATE_DATA_TO_API] (store, payload) {
    apiService.postAppList(payload.data).then(result => {
      store.commit({
        type: appMutations.SET_APP_SETTINGS_ID,
        appId: payload.data.appId
      })
      store.commit({
        type: appMutations.SET_APP_SETTINGS_NAME,
        appName: payload.data.appName
      })
      store.commit({
        type: appMutations.SET_APP_SETTINGS_LOGO_URL,
        appLogoUrl: payload.data.appLogoUrl
      })
      // resolve()
    }).catch((err) => {
      return err
    })
  },
  [appActions.UPDATE_TEXT_FROM_API] (store, payload) {
    // console.log('payload: ', payload)
    return new Promise(resolve => {
      if (payload !== undefined) {
        apiService.getText(payload.url).then(result => {
          store.commit({
            type: appMutations.GET_TEXT_FROM_API,
            editorText: result.htmlEditorContent,
            versionTimestamp: result.versionTimestamp
          })
          resolve({ editorContent: result.htmlEditorContent, versionTimestamp: result.versionTimestamp })
        }).catch((err) => {
          // console.log('UPDATE_TEXT_FROM_API err: ', err)
          return err
        })
      }
    })
  },
  [appActions.UPDATE_TEXT_TO_API] (store, payload) {
    return new Promise((resolve, reject) => {
      if (state.urlAPI !== '') {
        apiService.postText(state.urlAPI, payload).then(response => {
          store.commit({
            type: appMutations.POST_TEXT_TO_API,
            textFromAPI: payload
          })
          resolve()
        }, error => {
          reject(error)
        })
      }
    })
  },
  [appActions.UPDATE_APP_SETTINGS_FROM_API] (store, payload) {
    return new Promise(resolve => {
      apiService.getSpecificApp(payload).then(result => {
        // console.log('result: ', result.appSettings[0])
        let appSettings = result.appSettings[0]
        // console.log('appSettings: ', appSettings)
        // store.commit({
        //   type: appMutations.GET_APP_SETTINGS_FROM_API,
        //   appSettings: appSettings
        // })
        // ID
        store.commit({
          type: appMutations.SET_APP_SETTINGS_ID,
          appId: appSettings.appId
        })
        // Name
        store.commit({
          type: appMutations.SET_APP_SETTINGS_NAME,
          appName: appSettings.appName
        })
        // Logo Url
        store.commit({
          type: appMutations.SET_APP_SETTINGS_LOGO_URL,
          appLogoUrl: appSettings.logoUrl
        })
        // Document List
        store.commit({
          type: appMutations.SET_APP_SETTINGS_DOCUMENT_LIST,
          appDocumentList: appSettings.documents
        })
        // Colors
        store.commit({
          type: appMutations.SET_APP_SETTINGS_COLORS,
          appColors: appSettings.colors
        })
        // Font
        store.commit({
          type: appMutations.SET_APP_SETTINGS_FONT,
          appFont: appSettings.font
        })
        resolve()
      }).catch((err) => {
        // console.log('app settings err: ', err)
        return err
      })
    })
  },
  [appActions.UPDATE_APP_SETTINGS_ID] (store, payload) {
    store.commit({
      type: appMutations.SET_APP_SETTINGS_ID,
      appId: payload
    })
  },
  [appActions.UPDATE_APP_SETTINGS_NAME] (store, payload) {
    store.commit({
      type: appMutations.SET_APP_SETTINGS_NAME,
      appName: payload
    })
  },
  [appActions.UPDATE_APP_SETTINGS_LOGO_URL] (store, payload) {
    store.commit({
      type: appMutations.SET_APP_SETTINGS_LOGO_URL,
      appLogoUrl: payload
    })
  },
  [appActions.UPDATE_APP_SETTINGS_DOCUMENT_LIST] (store, payload) {
    return new Promise(resolve => {
      apiService.postSaveDocumentByAppAndName(payload.name, payload.document).then(() => {
        store.commit({
          type: appMutations.SET_APP_SETTINGS_DOCUMENT_LIST,
          appDocumentList: payload.data
        })
        // console.log('appDocumentList: payload.data', payload.data)
        // resolve()
      }).catch((err) => {
        // console.log('UPDATE_TEXT_TO_API err: ', err)
        return err
      })
    })
  },
  [appActions.UPDATE_APP_SETTINGS_DOCUMENT_LIST_ADD_LANGUAGE] (store, payload) {
    let currentDocument = state.appDocumentList.filter(item => item.title === payload.title)[0]
    currentDocument.languages.push(payload.language)
    // console.log('currentDocument: ', currentDocument)
    // console.log('appDocumentList: ', state.appDocumentList)
    return new Promise(resolve => {
      apiService.postSaveDocumentByAppAndName(state.appName.replace(' ', ''), currentDocument).then(() => {
        store.commit({
          type: appMutations.SET_APP_SETTINGS_DOCUMENT_LIST,
          appDocumentList: state.appDocumentList
        })
        // console.log('appDocumentList: state.appDocumentList', state.appDocumentList)
        // resolve()
      }).catch((err) => {
        // console.log('UPDATE_TEXT_TO_API err: ', err)
        return err
      })
    })
  },
  [appActions.UPDATE_APP_SETTINGS_COLORS] (store, payload) {
    store.commit({
      type: appMutations.SET_APP_SETTINGS_COLORS,
      appColors: payload
    })
  },
  [appActions.UPDATE_APP_SETTINGS_FONT] (store, payload) {
    store.commit({
      type: appMutations.SET_APP_SETTINGS_FONT,
      appFont: payload
    })
  },
  [appActions.SAVE_APP_SETTINGS_LOGO] (store, payload) {
    return new Promise((resolve, reject) => {
      apiService.postAppLogo(payload.name, payload.data).then((response) => {
        response.json().then((msg) => {
          store.commit({
            type: appMutations.SET_APP_SETTINGS_LOGO_URL,
            appLogoUrl: msg
          })
          resolve()
        }, error => {
          reject(error)
        })
      })
    })
  },
  [appActions.SAVE_APP_SETTINGS_COLORS] (store, payload) {
    // console.log('payload: ', payload)
    apiService.postAppColors(payload.name, payload.colors).then((response) => {
      store.commit({
        type: appMutations.SET_APP_SETTINGS_COLORS,
        appColors: payload.colors
      })
      // console.log(response)
      response.text().then((msg) => {
        // console.log(msg)
      })
    })
  },
  [appActions.SAVE_APP_SETTINGS_FONT] (store, payload) {
    // console.log('payload: ', payload)
    apiService.postAppFont(payload.name, { font: payload.font }).then((response) => {
      store.commit({
        type: appMutations.SET_APP_SETTINGS_FONT,
        appFont: payload.font
      })
      // console.log(response)
      response.text().then((msg) => {
        // console.log(msg)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
